import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SensorsDataService } from "./services/sensors-data.service";

@NgModule({
    imports: [CommonModule],
    providers: [SensorsDataService],
})
export class SensorsDataServiceModule {}
